import api from '@/services/utils/base';
import store from '@/store';

export default class Flow {
  get(id: string) {
    return api
      .get(`flows/${id}`)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
  }

  getName(id: string) {
    return api.get(`flows/name/${id}`);
  }

  postCreate(payload: object) {
    return api.post('flows', payload);
  }

  getList(params:any) {
    const newParams = {...params}
    const workspaceId = newParams.workspaceId
    delete newParams.workspaceId;
    return api
      .get('flows', {params:{
          ...newParams,
          workspaceIds:[...new Set([workspaceId,...store.getters.allPublicWorkspacesIds])]
        }
      })
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  putUpdate(id: string, payload: object) {
    return api.put(`flows/${id}`, payload);
  }

  delete(id: string) {
    return api.delete(`flows/${id}`);
  }

  postArchive(payload: object) {
    return api.post('flows/archive', payload);
  }

  postRestore(payload: object) {
    return api.post('flows/restore', payload);
  }

  postDuplicate(payload: object) {
    return api.post('flows/duplicate', payload);
  }

  updateStoreCache({workspaceId, countryId}) {
    return api.get('flows', {
      params:{
        status:'active',
        limit:'200',
        columns:['name', 'nameFull', 'id', 'countryId', 'workspaceId'],
        orderBy:'updated',
        orderDirection:'desc',
        workspaceIds:[...new Set([workspaceId,...store.getters.allPublicWorkspacesIds])],
        ...(countryId!==0 && {countryId})
      }
    }).then((res)=>{
      store.commit('updateFlowsCache', {
        workspaceId,
        countryId,
        data:res.data.payload
      });
      return Promise.resolve(res.data.payload);
    })
  }

  populateStoreCache() {
    return api.get('flows', {
      params:{
        status:'active',
        limit:'200',
        orderBy:'updated',
        orderDirection:'desc',
        columns:['name', 'nameFull', 'id', 'countryId', 'workspaceId'],
      }
    }).then((res)=>{
      store.commit('populateFlowsCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }
}
